import $ from "jquery";
import slick from 'slick-carousel';


if ($(".vertical-slider").length) {
  $(".vertical-slider").slick({
    vertical: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    dots: false,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    swipe: false
  });
}

$(".stories-slider-for").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  centerMode: false,
  autoplay: true,
  autoplaySpeed: 4000,
  asNavFor: '.stories-slider-nav'
});


$(document).ready(function () {
  $('.stories-slider-nav').each(function () {
    var container = $(this);
    var service = container.data('service');
    console.log(service)

    $(".stories-slider-nav").slick({
      slidesToShow: service,
      slidesToScroll: 1,
      asNavFor: '.stories-slider-for',
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      arrows: false,
    });
  });
});



$(".who-we-serve-slider").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  centerMode: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]

});

$(".partners-slider").slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  prevArrow: $('.prev'),
  nextArrow: $('.next'),
  centerMode: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]

});

